import gql from 'graphql-tag';

export const GET_SITEINI_LIST = gql`
  query ($country: String){
    siteiniList(country: $country) {
      id
      site
      country
      encrypted
      decrypt_key {
        status
        key
      }
      channelCount
      channelUsedCount
      cookies
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/siteini/list.js